module.exports = __webpack_public_path__ + "/build/web/images/testimonials-right-1.df48f0db9c53c10145b26230afc1cbc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/testimonials-right-1.jpg
// module id = 200
// module chunks = 13